import React from 'react';

const Logo = ({ height = 32, showText = true }) => {
  const scale = height / 44;
  const width = showText ? Math.round(220 * scale) : Math.round(50 * scale);
  const viewBox = showText ? "0 0 220 44" : "0 0 50 44";

  return (
    <svg
      width={width}
      height={height}
      viewBox={viewBox}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      {/* Isometric cube */}
      <path d="M22 12 L22 32 L6 24 L6 14 Z" fill="#3b82f6" opacity="0.35" />
      <path d="M22 12 L38 14 L38 24 L22 32 Z" fill="#2563eb" opacity="0.55" />
      <path d="M6 14 L22 6 L38 14 L22 12 Z" fill="#60a5fa" opacity="0.25" />
      <path
        d="M22 6 L38 14 L38 24 L22 32 L6 24 L6 14 Z"
        stroke="#3b82f6"
        strokeWidth="2.2"
        strokeLinejoin="round"
        fill="none"
      />
      <line x1="22" y1="12" x2="22" y2="32" stroke="#3b82f6" strokeWidth="1.4" opacity="0.5" />
      <line x1="22" y1="12" x2="6" y2="14" stroke="#3b82f6" strokeWidth="1.4" opacity="0.5" />
      <line x1="22" y1="12" x2="38" y2="14" stroke="#3b82f6" strokeWidth="1.4" opacity="0.5" />

      {/* Signal waves */}
      <path d="M36 10 C39 8, 41 6, 42 3" stroke="#3b82f6" strokeWidth="1.8" strokeLinecap="round" fill="none" />
      <path d="M38 12 C42 9, 44 7, 46 3" stroke="#3b82f6" strokeWidth="1.8" strokeLinecap="round" fill="none" opacity="0.6" />
      <path d="M40 14 C44 10, 47 8, 49 3" stroke="#3b82f6" strokeWidth="1.8" strokeLinecap="round" fill="none" opacity="0.3" />

      {/* Company name */}
      {showText && (
        <text
          x="58"
          y="30"
          fontFamily="'Inter', system-ui, -apple-system, sans-serif"
          fontWeight="700"
          fontSize="26"
          letterSpacing="-0.5"
        >
          <tspan fill="#ffffff">Clarity</tspan>
          <tspan fill="#3b82f6">Box</tspan>
        </text>
      )}
    </svg>
  );
};

export default Logo;
